import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomFeeRow from './CustomFeeRow';

interface SubjectFeeDetailProps {
  totalExamFee: string;
  totalFee: string;
  totalGst: string;
  totalPayable: string;
  gstAbsorbed: string;
}

const SubjectFeeDetail = ({
  totalExamFee,
  totalFee,
  totalGst,
  totalPayable,
  gstAbsorbed,
}: SubjectFeeDetailProps) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: 16 }}>
      <CustomFeeRow
        label={t('exam->>ReviewExam.TotalExamFees')}
        value={t('components->>SelectedSubjectReview.Amount (SGD)')}
        currencyDenomination={false}
        variant="header"
      />
      <CustomFeeRow label={t('exam->>ReviewExam.Goods and Services Tax (GST)')} value={totalGst} />
      <CustomFeeRow
        label={t('components->>SelectedSubjectReview.TotalPayableFeeInclGST')}
        value={totalFee}
      />
      {gstAbsorbed !== '0.00' && (
        <CustomFeeRow
          label={t('components->>SelectedSubjectReview.GSTAbsorbed')}
          value={gstAbsorbed}
        />
      )}

      <CustomFeeRow
        label={t('components->>SelectedSubjectReview.TotalPayable')}
        value={totalPayable}
        variant="footer"
      />
    </div>
  );
};

export default SubjectFeeDetail;
